    document.addEventListener('DOMContentLoaded', function () {
        const swiper = new Swiper('.swiper.media-room-new-design', {
            slidesPerView: 3,
            grid: {
                rows: 2,
                fill: 'row',
            },
            spaceBetween: 30,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    grid: {
                        rows: 2,
                        fill: 'row',
                    },
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 1.8,
                    grid: {
                        rows: 2,
                        fill: 'row',
                    },
                    spaceBetween: 25,
                },
                1024: {
                    slidesPerView: 3,
                    grid: {
                        rows: 2,
                        fill: 'row',
                    },
                    spaceBetween: 30,
                },
            },
        });
    });